import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import AboutUsSiteInnerContainer from 'components/about-us/AboutUsSiteInnerContainer';
import CarouselButtons from 'components/carousel2025/CarouselButtons';
import EmblaCarousel from 'components/carousel2025/EmblaCarousel';
import { default as Header } from 'components/dashboard/common/DashboardComponentHeader';
import ImageWithFallback from 'components/ImageWithFallback';
import RoundedButton from 'components/RoundedButton';
import useEmblaCarousel from 'embla-carousel-react';
import { useUIStore } from 'hooks/stores/useUIStore';
import { useIsMobile } from 'hooks/ui/useIsMobile';
import styles from './what-can-we-win.module.css';
import WhatCanWeWinCard, { TSharedWinPrize } from './WhatCanWeWinCard';
import { MAX_REFERRALS } from '@daymade/common-lib/constants';

const prizeOptions: TSharedWinPrize[] = [
  {
    win: '£5,000 gift card',
    friendWin: '4 main + bonus + boost',
    image:
      'https://daymade-website-assets.s3.amazonaws.com/2026/referrals/what-can-we-win/DAYMAKERboost.svg',
  },
  {
    win: '£500 gift card',
    friendWin: '4 main numbers',
    image:
      'https://daymade-website-assets.s3.amazonaws.com/2026/referrals/what-can-we-win/diamond.svg',
  },
  {
    win: '£200 gift card',
    friendWin: '3 main + the bonus number',
    image:
      'https://daymade-website-assets.s3.amazonaws.com/2026/referrals/what-can-we-win/platinum.svg',
  },
  {
    win: '£15 gift card',
    friendWin: '3 main numbers',
    image:
      'https://daymade-website-assets.s3.amazonaws.com/2026/referrals/what-can-we-win/gold.svg',
  },
  {
    win: '£5 gift card',
    friendWin: '2 main + the bonus number',
    image:
      'https://daymade-website-assets.s3.amazonaws.com/2026/referrals/what-can-we-win/silver.svg',
  },
  {
    win: 'free entry',
    friendWin: '2 main numbers',
    variedImage: true,
    image:
      'https://daymade-website-assets.s3.amazonaws.com/2026/referrals/what-can-we-win/free-entry.png',
  },
  {
    win: 'token',
    friendWin: '1 main + 1 bonus number',
    image:
      'https://daymade-website-assets.s3.amazonaws.com/2026/referrals/what-can-we-win/token.png',
  },
  {
    win: '£10K Giveaway',
    winPrefix: 'entries into the',
    friendWin: 'at least 1 number',
    image:
      'https://daymade-website-assets.s3.amazonaws.com/2026/referrals/what-can-we-win/giveaway-entries.png',
  },
];

export const WhatCanWeWin = (props: { inviteesCount: number }) => {
  const { isMobile } = useIsMobile();
  const uiStore = useUIStore();
  const emblaCarouselInfo = useEmblaCarousel({
    loop: false,
    duration: 10,
    inViewThreshold: 0.1,
  });

  return (
    <AboutUsModule background="grey">
      <AboutUsSiteContainer overlapBelow>
        <AboutUsSiteInnerContainer background="white" borderRadius withPadding>
          <Header
            title="What can we win?"
            subtitle="Win gift cards and other rewards"
            separator
            banner={
              <div className={styles.winWithFriendsBadge}>
                <ImageWithFallback
                  src="https://daymade-website-assets.s3.amazonaws.com/2026/referrals/win-with-friends-badge.svg"
                  layout="fill"
                  alt=""
                />
              </div>
            }
          />
          <div className={styles.carouselContainer}>
            <EmblaCarousel
              className={styles.carousel}
              emblaCarouselInfo={emblaCarouselInfo}
              hidePips={isMobile ? false : true}
              items={prizeOptions.map((x) => (
                <WhatCanWeWinCard sharedWinPrize={x} />
              ))}
            >
              <CarouselButtons
                changeSelectedIndex={(x) =>
                  x < 0
                    ? emblaCarouselInfo[1]?.scrollPrev()
                    : emblaCarouselInfo[1]?.scrollNext()
                }
              />
            </EmblaCarousel>
          </div>
          <div className={styles.inviteButtonWrapper}>
            <RoundedButton
              className={styles.inviteButton}
              rebrandDm2025
              onClick={() =>
                uiStore.setShowInviteFriendsModal(
                  true,
                  props.inviteesCount >= MAX_REFERRALS,
                )
              }
            >
              Invite friends
            </RoundedButton>
          </div>
        </AboutUsSiteInnerContainer>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};
